import React from "react";
import { Box, IconButton } from "@mui/material";

export interface ButtonGroupSquareItem {
  icon?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  "aria-label"?: string;
  component?: React.ReactNode;
}

export interface ButtonGroupSquareProps {
  items: ButtonGroupSquareItem[];
  variant?: "desktop" | "mobile";
}

const ButtonGroupSquare: React.FC<ButtonGroupSquareProps> = ({
  items,
  variant = "desktop",
}) => {
  const isMobile = variant === "mobile";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #D4D4D4",
        borderRadius: isMobile ? "50px" : "12px",
        backgroundColor: "#fff",
      }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={index}>
            {item.component ? (
              item.component
            ) : (
              <IconButton
                sx={{
                  borderRadius: isMobile ? "50px" : "8px",
                  padding: "8px 16px !important",
                  color: "#6B6E7B",
                  height: isMobile ? "32px" : "40px",
                }}
                size="small"
                onClick={item.onClick}
                disabled={item.disabled}
                aria-label={item["aria-label"]}
              >
                {item.icon &&
                  React.cloneElement(item.icon as React.ReactElement, {
                    height: isMobile ? "16px" : "20px",
                  })}
              </IconButton>
            )}

            {!isLast && (
              <Box
                sx={{
                  width: "1px",
                  height: isMobile ? "32px" : "40px",
                  backgroundColor: "#E0E0E0",
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default ButtonGroupSquare;
